import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button } from '@mui/material';
import { startCase } from 'lodash';
import { Check } from 'lucide-react';
import { getCurrentTerms } from '../../../shared/projectTypeUtils';

export const constructTable = (field, handleClick, finalData) => {
    const getWidth = () => {
        return 200;
    };
    
    const TERMS = getCurrentTerms();
    
    // Create a mapping between dynamic field names and actual data properties
    const fieldToPropertyMap = {
        [`${TERMS.TRACKER_LABEL}_type_id`]: 'tracker_type_id',
        [`${TERMS.TRACKER_LABEL}_type`]: 'tracker_type',
        'count': 'count',
        'progress': 'progress'
    };
    
    const data = field.map((col) => {
        const width = getWidth(col);
        const dataProperty = fieldToPropertyMap[col] || col;
        
        return {
            field: col,
            width,
            minWidth: width,
            headerName: startCase(col),
            sortable: false,
            filterable: true,
            flex: 1,
            renderCell: (params) => {
                // For non-progress fields, extract the actual value using the mapped property
                if (col !== 'progress') {
                    return <div>{params.row[dataProperty]}</div>;
                }
                
                // For progress field, keep the special rendering
                const value = finalData?.find(obj => Object.keys(obj).includes(String(params?.row?.tracker_type_id)));
                return (
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", mt: 1 }}>
                        <Button variant='contained' onClick={(e) => handleClick(e, params?.row)}>Mark Progress</Button>
                        {value?.[params.row?.tracker_type_id]?.activity_id && <Check color='green' />}
                    </Box>
                );
            }
        };
    });
    
    return data;
};

export default function TrackerTypeTable(props) {
    const { loader, rows, setOpenSecondModal, setMarkData, finalData, markData, handleSubmit, setPartCount, setTotalCount, setSelectedPier, setSelectedTt } = props;
    const TERMS = getCurrentTerms();
    const field = [`${TERMS.TRACKER_LABEL}_type_id`, `${TERMS.TRACKER_LABEL}_type`, "count", "progress"];

    const handleClick = (event, record) => {
        event.stopPropagation();
        setOpenSecondModal(true);
        setMarkData(record);
        if(markData?.tracker_type_id !== record?.tracker_type_id) {
            setPartCount(null);
            setTotalCount(null);
            setSelectedPier([]);
            setSelectedTt([]);
        }
    };
    
    const columns = constructTable(field, handleClick, finalData);

    return (
        <Box sx={{ height: 400, width: '100%', mt: 0.5 }}>
            <DataGrid
                rows={rows.map((row, index) => ({ id: index, ...row }))}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                hideFooter={true}
                disableColumnMenu
                disableSelectionOnClick
                sx={{
                    mb: 2,
                    '& .MuiDataGrid-columnSeparator': { color: '#fff' },
                    '& .MuiDataGrid-columnHeader': {
                        fontWeight: 600,
                        backgroundColor: '#f16253',
                        color: '#ffffff',
                    },
                }}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button variant='contained' loading={loader} onClick={handleSubmit}>
                    Submit
                </Button>
            </Box>
        </Box>
    );
}